var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9243 16.9231L13.5858 13.5846M15.3858 9.23075C15.3858 10.4479 15.0249 11.6376 14.3487 12.6496C13.6725 13.6616 12.7114 14.4504 11.5869 14.9162C10.4625 15.3819 9.22515 15.5038 8.03142 15.2664C6.83769 15.0289 5.74118 14.4428 4.88055 13.5822C4.01992 12.7215 3.43382 11.625 3.19637 10.4313C2.95892 9.23758 3.08079 8.00024 3.54656 6.87578C4.01233 5.75131 4.80109 4.79021 5.81308 4.11401C6.82508 3.43782 8.01486 3.0769 9.23197 3.0769C10.8641 3.0769 12.4293 3.72525 13.5834 4.87932C14.7375 6.03339 15.3858 7.59865 15.3858 9.23075Z",
    stroke: "#222729",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.586035f8b2ee17d44ac5fd9c56cd0339.svg";
export { ForwardRef as ReactComponent };